import clsx from 'clsx';

import { CheckmarkIcon, ShippingIcon, Typography } from '@ag1/ui';

import { AddToCartSectionSubscriptionProductType } from 'shared/studio/AddToCartSectionShop/types';

import styles from './AssurancesBaB.module.scss';

type AssurancesBaBProps = {
  assurances: string[];
  selectedVariantSubscriptionType?: AddToCartSectionSubscriptionProductType;
  className?: string;
  isSubscription?: boolean;
  isPdp?: boolean;
};

export const AssurancesBaB = ({
  assurances,
  selectedVariantSubscriptionType,
  className,
  isPdp = false,
  isSubscription = true
}: AssurancesBaBProps) => {
  return (
    <div className={clsx(styles.assurancesWrapper, className)}>
      {assurances?.map((assurance) => {
        const isFreeShipping = assurance.toLowerCase().includes('free shipping');

        // Don't display free shipping assurance if selectedVariantSubscriptionType is 'oneTime'
        if (isFreeShipping && selectedVariantSubscriptionType === 'oneTime') {
          return null;
        }

        return (
          <div key={assurance} className={styles.iconTextWrapper}>
            {isSubscription && (
              <span className={styles.iconCheck}>
                {isFreeShipping ? <ShippingIcon /> : <CheckmarkIcon size={12} />}
              </span>
            )}
            <Typography
              noPadding
              size="3"
              className={clsx({ [styles.assuranceTextPdp]: isPdp })}
              color="black-new"
              variant="body"
              fontStyle={isSubscription ? 'normal' : 'italic'}>
              {assurance}
            </Typography>
          </div>
        );
      })}
    </div>
  );
};
